<template>
  <div class="container">
    <div class="card mt-3" style="align-items: center;">
      <div class="card-header" style="width: 100%;">
        <b-row align-h="between" align-v="center">
          <h4 class="mb-0">Detalle del Siniestro</h4>
          <b-button variant="dark" @click="back()">Volver </b-button>
        </b-row>
      </div>
      <div v-if="isBusy" class="text-center text-danger space">
        <b-spinner class="align-middle"></b-spinner>
      </div>
      <template v-if="!isBusy">
        <template>
          <div class="card-body bordered">
            <table class="table table-striped">
              <tbody>
              <tr>
                <th class="desc">Nro. Siniestro</th>
                <td class="contenido">{{data.nroSiniestro}}</td>
              </tr>
              <tr>
                <th class="desc">Gravedad</th>
                <td class="contenido">{{data.idGravedad}}</td>
              </tr>
              <tr>
                <th class="desc">Patente</th>
                <td class="contenido">{{data.patente}}</td>
              </tr>
              <tr>
                <th class="desc">Marca</th>
                <td class="contenido">{{data.marca}}</td>
              </tr>
              <tr>
                <th class="desc">Modelo</th>
                <td class="contenido">{{data.modelo}}</td>
              </tr>
              <tr>
                <th class="desc">Fecha de declaracion de siniestro</th>
                <td class="contenido">{{data.fecIngreso}}</td>
              </tr>
              <tr>
                <th class="desc">RUT Conductor</th>
                <td class="contenido">{{data.rutConductor}}</td>
              </tr>
              <tr>
                <th class="desc">Nombre conductor</th>
                <td class="contenido">{{data.nombreconductor}}</td>
              </tr>
              <tr>
                <th class="desc">Fecha Accidente</th>
                <td class="contenido">{{data.fecAccidente}}</td>
              </tr>
              <tr>
                <th class="desc">Usuario ingreso</th>
                <td class="contenido">{{data.usuarioIngreso}}</td>
              </tr>
              <tr v-if="$route.name === 'siniestroDetail'">
                <th class="desc">Jurisdicción</th>
                <td class="contenido">{{data.jurisdiccion}}</td>
              </tr>
              <tr v-if="$route.name === 'siniestroDetail'">
                <th class="desc">Sucursal ingreso</th>
                <td class="contenido">{{data.idSucursalIngreso}}</td>
              </tr>
              <tr>
                <th class="desc">Autorizado reparación</th>
                <td class="contenido">{{data.autorizadoReparacion ? "Si" : "No"}}</td>
              </tr>
              <tr>
                <th class="desc">¿Visto por flota?</th>
                <td class="contenido">{{data.chk_VistoPorFlota ? "Si" : "No"}}</td>
              </tr>
              <tr v-if="$route.name === 'siniestroDetail'">
                <th class="desc">Origen siniestro</th>
                <td class="contenido">{{data.origen}}</td>
              </tr>
              <tr>
                <th class="desc">¿Declara?</th>
                <td class="contenido">{{data.chkDeclara ? "Si" : "No"}}</td>
              </tr>
              <tr>
                <th class="desc">Usuario Declara</th>
                <td class="contenido">{{data.usuarioDeclara}}</td>
              </tr>
              <tr>
                <th class="desc">Fotos</th>
                <td class="contenido">
                  <zip
                      :data="fotos"
                      :title="'Descargar Fotos'"
                      :disabled="disabled"
                      :format="'jpg'"
                  ></zip>
                </td>
              </tr>
              <tr>
                <th class="desc">Observaciones</th>
                <td class="contenido">{{data.obser}}</td>
              </tr>
              <tr>
                <th class="desc">RUT Empresa</th>
                <td class="contenido">{{data.idRutEmpresa}}</td>
              </tr>
              <tr>
                <th class="desc">Nro. asignación unidad</th>
                <td class="contenido">{{data.idAsignacionDen}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "../../../axios";
import CreateZipButton from "@/components/create-zip-button";

export default {
  components: {
    zip: CreateZipButton
  },
  data() {
    return {
      data: [],
      nroSiniestro: parseInt(this.$store.getters["hideValue/detailId"]),
      isBusy: false,
      buttonClicked: undefined,
      fotos: [],
      disabled: true
    };
  },
  beforeMount() {
    this.getDetail();
    this.downloadFoto();
  },
  methods: {
    back(){
      history.back();
    },
    getDetail() {
      this.isBusy = true;
      axios
          .get(`/GetDetalleSiniestro/${this.$store.getters["hideValue/detailId"]}`)
          .then((detalle) => {
            this.isBusy = false;
            this.data = detalle.data;
          })
          .catch(() => {
            this.$bvToast.toast(this.$t('NoData.error.message').toString(), {
              title: this.$t('NoData.error.title').toString(),
              variant: 'danger',
              solid: true
            });
            this.isBusy = false;
          });
    },
    downloadFoto() {
      this.buttonClicked = this.$store.getters["hideValue/detailId"];
      axios
          .get(`/GetFotosSiniestro/${this.$store.getters["hideValue/detailId"]}`)
          .then((doc) => {
            for (let i = 0; i < doc.data.length; i++) {
              this.fotos.push(doc.data[i].image)
            }
            if (this.fotos.length > 0) this.disabled = false;
            })
    },
    formatFecha(fecha){
      return moment(fecha).format("DD-MM-YYYY") + " " + moment(fecha).format("HH:mm:ss")
    }
  },
};
</script>

<style scoped>
.card-header:first-child{
  border-radius: 0.25rem;
}
.desc{
  width: 200px;
  text-align: left;
}
.bordered{
  border: solid 1px rgb(238, 111, 111);
  border-radius: 1rem;
  width: 70%;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
